import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/ContactUs.css';
import '../css/about.css';

const FdWms
 = () => {
  const underlineRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (underlineRef.current) {
        underlineRef.current.classList.add('animate');
      }
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0,    top: '-122px' }}>
            <div className="container about-content">
                <div className="row">
                    <div className="col-lg-6 col-md-8 col-12 about-text">
                        <h1 className="about-title text-white">FD-WMS <span className="comingSoon">(Coming Soon)</span></h1>
                        <h2 className="about-subtitle">Full Drilling Well Integrated Management Services</h2>
                        <div className="about-underline" ref={underlineRef}></div>
                        <p className="about-desc text-white">Petrochoice is forging strategic partnerships with leading industry service providers, uniting Rig contractors, Cementing ,Mud, Directional providers, and more.</p>
                    </div>
                </div>
            </div>
    </div>

      {/* Content Section */}
      {/* Content Section */}
    <div className="container-xxl py-5">
    <div className="container">
        <div className="row g-5 align-items-center">
        
        {/* Left Image Column */}
        <div className="col-lg-4">
            <img
            src={require('../assets/level2-600x402.jpg')} 
            alt="Integrated Drilling"
            className="img-fluid rounded shadow"
            />
        </div>

        {/* Right Text Column */}
        <div className="col-lg-8">
            <h3 className="fw-bold mb-3">Full Drilling Well Integrated Management Services</h3>
            <p className="mb-2">
            Our FD-WIMS streamlines operations, reduces costs, and boosts production. We leverage cutting-edge technology, collaborate with regional teams, and provide experienced coordinators for seamless logistics. <br/><br/>
            Our experts ensure drilling and completion adhere to industry standards, acting as a single point of contact for all Petrochoice services. With DIMS, we bridge resource gaps, helping clients meet their goals. <br/><br/> 
            For drilling, completion, and more, Petrochoice delivers cost-effective, time-saving solutions. We’re your partner for operational excellence in the oil and gas industry.


            </p>
            <p className="mb-0">
            Two categories of service are provided.
            </p>
        </div>


        </div>
    </div>
    </div>

    </>
  );
};

export default FdWms;
